import React from "react"
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import Background from "../parts/background/background.js"

const HeroBanner = ({ blok }) => (
  <section
    className="block_hero_banner content_block"
    {...storyblokEditable(blok)}
    key={blok._uid}
  >
    <Background blok={blok.background} />
    <div className="inner">
      {blok.content && (
        <div className="block-content gs_reveal">
          {blok.content.map(blok => (
            <StoryblokComponent key={blok._uid} blok={blok} />
          ))}
        </div>
      )}
    </div>
    <div className="logos-container">
      <div className="inner">
        <div
          className="logos logos--desktop"
          style={{ "--count": blok.logos_desktop.length }}
        >
          {blok.logos_desktop.map(blok => (
            <StoryblokComponent key={blok._uid} blok={blok} />
          ))}
        </div>
      </div>
    </div>
  </section>
)

export default HeroBanner
